export function isImageFile(contentType: string): boolean {
  return contentType.toLocaleLowerCase().startsWith('image')
}

export function isVideoFile(contentType: string): boolean {
  return contentType.toLocaleLowerCase().startsWith('video')
}
